import { indexItems } from '@/mocks/home';

const iconBgColors = [
  'bg-accent-100 text-accent-600',
  'bg-primary-100 text-primary-600',
  'bg-secondary-100 text-secondary-700',
  'bg-accent-100 text-accent-600',
  'bg-primary-100 text-primary-600',
  'bg-secondary-100 text-secondary-700',
  'bg-accent-100 text-accent-600',
  'bg-primary-100 text-primary-600',
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-16 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950">分类索引</h2>
          <p className="mt-2 text-sm text-foreground-500">按题材快速定位，找到你喜欢的韩漫类型</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 md:gap-4">
          {indexItems.map((item, i) => (
            <a
              key={i}
              href="#ranking"
              className="group bg-background-50 rounded-xl p-4 md:p-5 flex flex-col items-center text-center cursor-pointer hover:ring-2 hover:ring-primary-200 transition-all"
            >
              <div className={`w-12 h-12 md:w-14 md:h-14 rounded-xl ${iconBgColors[i]} flex items-center justify-center mb-3 group-hover:scale-110 transition-transform`}>
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-1 whitespace-nowrap">{item.name}</h3>
              <span className="text-xs text-foreground-400">{item.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}